import { useState } from 'react';
import { createPortal } from 'react-dom';
import CreateListRow from '@alltrails/shared/components/CreateListRow';
import { usersContentPrivacyPolicy } from 'utils/UserUtils';
import SaveToListModal from '@alltrails/shared/components/modals/SaveToListModal';
import { PageStrings } from '@alltrails/shared/utils/constants/pageStringHelpers';
import CustomProvider from 'components/CustomProvider';
import useUser from 'hooks/useUser';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { wrapUrlSafe } from '../../../utils/language_support_util';
import * as styles from './CreateListPopupButton.module.scss';

type Props = {
  allowEditing: boolean;
  favoritesRow: JSX.Element;
};

function CreateListPopupButton({ allowEditing, favoritesRow }: Props) {
  const languageRegionCode = useLanguageRegionCode();
  const user = useUser();
  const [showModal, toggleShowModal] = useState(false);

  const renderModal = () => (
    <SaveToListModal
      closeModal={() => toggleShowModal(false)}
      handleModalListCreated={(list: any) => {
        window.location.href = wrapUrlSafe(`/explore/list/${list.slug}`, languageRegionCode);
      }}
      initialPrivacyPolicy={usersContentPrivacyPolicy(user, 'lists')}
      createListOnly
      page={PageStrings.LISTS_PAGE}
    />
  );

  if (allowEditing) {
    return (
      <CustomProvider>
        <div className={styles.createListContainer}>
          <CreateListRow handleOnClick={() => toggleShowModal(true)} />
        </div>
        {favoritesRow}
        {showModal && createPortal(renderModal(), document.getElementById('modalPortal'))}
      </CustomProvider>
    );
  }

  return favoritesRow;
}

export default function CreateListPopupButtonWrapper({ allowEditing, favoritesRow }: Props) {
  return (
    <CustomProvider>
      <CreateListPopupButton allowEditing={allowEditing} favoritesRow={favoritesRow} />
    </CustomProvider>
  );
}
